import { render, staticRenderFns } from "./using-ie-dialog.vue?vue&type=template&id=521d664d&scoped=true&"
import script from "./using-ie-dialog.vue?vue&type=script&lang=js&"
export * from "./using-ie-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d664d",
  null
  
)

export default component.exports